import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { useAuth } from '@/contexts/auth-context'
import { usePageStateStore } from '@/reducers'

export const ProtectedRoute = () => {
  const { isAuth, loading } = useAuth()
  const location = useLocation()
  const authToken = usePageStateStore.use.authToken() || ''
  const setProtectedRouteRedirectPath =
    usePageStateStore.use.setProtectedRouteRedirectPath()

  if (!authToken) {
    setProtectedRouteRedirectPath(location.pathname.replace('/', ''))
  }

  if (loading) {
    return (
      <div data-testid="container-protectedroute-loading">
        Account loading...
      </div>
    )
  }

  return isAuth ? (
    <Outlet />
  ) : (
    <Navigate to="/EasyLogin" replace state={{ from: location }} />
  )
}
